export const countdown = (theme) => ({
    container: {
        backgroundColor: theme.customPalette.neutralGr02,
        padding: theme.spacing(3),
    },
});
